<template>
    <div class="d-inline-block float-md-start me-1 mb-1 search-input-container shadow bg-foreground flex-grow-1">
        <div class="input-group">
            <span class="search-magnifier-icon">
                <svg data-v-6ad05094="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-search"><circle data-v-6ad05094="" cx="9" cy="9" r="7"></circle><path data-v-6ad05094="" d="M14 14L17.5 17.5"></path></svg>
            </span>
            <input 
                type="text" 
                class="form-control" 
                v-model="searchText"
                @input="onInputChange"
                placeholder="Cerca prodotto per nome/sku"
            >
        </div>
    </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
    data() {
        return {
            searchText: ''
        }
    },

    methods: {
        // Metodo per ottenere il testo della ricerca
        getTextSearch() {
            return this.searchText;
        },

        // Method to set the search text
        setTextSearch(value) {
            this.searchText = value || '';
        },

        // Metodo debounced per emettere l'evento search
        onInputChange: debounce(function() {
            this.$emit('search', this.searchText);
        }, 300)
    }
}
</script>
